module.exports = __webpack_public_path__ + "img/zutto-new-places.4fb113e.jpg";